var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgClose = function SvgClose(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "18px",
    viewBox: "0 0 18 18",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "04-metrics-list--design-prod-r2",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(-1130.000000, -126.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "data-series-panel-_expand-tree",
    transform: "translate(746.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "content"
  }, /*#__PURE__*/React.createElement("g", {
    id: "search-_normal-state",
    transform: "translate(0.000000, 117.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "controls",
    transform: "translate(32.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "search"
  }, /*#__PURE__*/React.createElement("g", {
    id: "form"
  }, /*#__PURE__*/React.createElement("g", {
    id: "input"
  }, /*#__PURE__*/React.createElement("g", {
    id: "clear",
    transform: "translate(352.000000, 9.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ic_close_24px"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.72125,4.27875 L13.72125,4.27875 C13.4292294,3.98672944 12.9557706,3.98672944 12.66375,4.27875 L9,7.9425 L5.33625,4.27875 C5.04422944,3.98672944 4.57077056,3.98672944 4.27875,4.27875 L4.27875,4.27875 C3.98672944,4.57077056 3.98672944,5.04422944 4.27875,5.33625 L7.9425,9 L4.27875,12.66375 C3.98672944,12.9557706 3.98672944,13.4292294 4.27875,13.72125 L4.27875,13.72125 C4.57077056,14.0132706 5.04422944,14.0132706 5.33625,13.72125 L9,10.0575 L12.66375,13.72125 C12.9557706,14.0132706 13.4292294,14.0132706 13.72125,13.72125 L13.72125,13.72125 C14.0132706,13.4292294 14.0132706,12.9557706 13.72125,12.66375 L10.0575,9 L13.72125,5.33625 C14.0132706,5.04422944 14.0132706,4.57077056 13.72125,4.27875 Z",
    id: "Shape",
    fill: "#777776",
    fillRule: "nonzero"
  })))))))))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgClose, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/close.23519800.svg";
export { ForwardRef as ReactComponent };